export default __webpack_public_path__ + "static/media/photo4.3aba8e22.jpg";